import _ from 'lodash';
import { LANG_PREFERENCE } from '../state/actions/locale';

const sessionFields = [
  'accessToken',
  'userId',
  'affiliateId',
  'singleAffiliateUser',
  'isSuperUser',
];

export const sessionKey = 'app.session';

export const loadSession = () => {
  const serialized = localStorage.getItem(sessionKey);

  if (!serialized) {
    return null;
  }

  try {
    return _.pick(JSON.parse(serialized), sessionFields);
  } catch (err) {
    console.warn('[App.Session]: can not parse');
    localStorage.removeItem(sessionKey);
  }

  return null;
};

export const updateSession = (updates) => {
  const session = { ...loadSession(), ...updates };
  localStorage.setItem(sessionKey, JSON.stringify(_.pick(session, sessionFields)));
};

export const clearSession = () => {
  localStorage.removeItem(sessionKey);
  localStorage.removeItem(LANG_PREFERENCE);
};



// WEBPACK FOOTER //
// ./src/app/session.js